import { createReducer } from "@reduxjs/toolkit";
import {
  adminResetRetrieveFundingRequestEligibility,
  adminRetrieveFundingRequestEligibility,
} from "./retrieve-funding-request-eligibility";
import type { RetrievalState } from "@redux/state/shared-types";
import type { FundingRequestEligibilityVM } from "@shared-kernel/application/ports/student/student-repository";

const initialState: RetrievalState<FundingRequestEligibilityVM | null> = { fetching: "idle", data: null };

export const adminRetrieveFundingRequestEligibilityReducer = createReducer<RetrievalState<FundingRequestEligibilityVM | null>>(
  initialState,
  builder => {
    builder.addCase(adminRetrieveFundingRequestEligibility.fulfilled, (state, { payload }) => {
      return {
        ...state,
        data: payload,
        fetching: "success",
      };
    });
    builder.addCase(adminRetrieveFundingRequestEligibility.pending, state => {
      return {
        ...state,
        fetching: "pending",
      };
    });
    builder.addCase(adminRetrieveFundingRequestEligibility.rejected, state => {
      return {
        ...state,
        fetching: "failed",
      };
    });
    builder.addCase(adminResetRetrieveFundingRequestEligibility, () => {
      return initialState;
    });
  },
);
